export function setPageMeta(meta: Record<string, string>): void {
    const baseTitle: string = "Jack Burton";
    document.title = [meta.title, baseTitle].filter(v => v).join(" > ");
}